import React, { useState } from "react";
import styles from "./AddTaxrate.module.css";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import { IoDocumentTextOutline } from "react-icons/io5";

const AddTaxrate = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: "",
    rate: "",
    code: "",
  });

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleCancel = () => {
    dispatch(closeModal());
  };

  const handleSave = () => {
    console.log("Submitted Tax Rate:", formData);
    dispatch(closeModal());
  };

  return (
    <div className={styles.modal}>
      <div className={styles.header}>
        <HeadingAndIcon
          icon={<IoDocumentTextOutline />}
          heading="Add tax rate"
        />
        <ToClose onClose={handleCancel} />
      </div>

      <div className={styles.content}>
        <HeadingAndData
          label="Name"
          name="name"
          placeholder="Enter your name"
          value={formData.name}
          onChange={handleChange("name")}
          required
        />
        <HeadingAndData
          label="Tax rate (%)"
          name="rate"
          placeholder="Please enter value"
          value={formData.rate}
          onChange={handleChange("rate")}
        />
        <HeadingAndData
          label="Item Code"
          name="code"
          placeholder="Please enter item code"
          value={formData.code}
          onChange={handleChange("code")}
          required
        />

        <div className={styles.actions}>
          <SaveAndCancel onCancel={handleCancel} onSave={handleSave} />
        </div>
      </div>
    </div>
  );
};

export default AddTaxrate;
